import AddDeviceContainer from './containers/AddDeviceContainer'

export default AddDeviceContainer
